import React, { useState } from "react";
import { GenerateUser } from "../../types";
import { createUser } from "../../services/api";


const CreateUser: React.FC = () => {
  const [formData, setFormData] = useState<GenerateUser>({
    sid: "",
    username: "",
    userid: "",
    usertype: "",
    details: "",
    primary_group: "",
    email: "",
    mobileno: "",
    createdOn: "",
    enabled: false,
    system: "",
    mode: "",
    initialPassword: "",
    tools: "",
    setupDate: "",
    expiryDate: "",
    duration: "",
    automation: "",
    puttyStart: "",
    puttyStatus: "",
    puttyExpiry: "",
    puttyDuration: "",
    puttyFQDN: "",
    puttyExtensionTill: "",
    puttyExtensionReason: "",
    vncStart: "",
    vncStatus: "",
    vncExpiry: "",
    vncDuration: "",
    vncFQDN: "",
    vncExtensionTill: "",
    vncExtensionReason: "",
    lastUpdate: "",
    address: "",
    remarks: ""
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (e.target as HTMLInputElement).checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // console.log(JSON.stringify(formData, null, 2));
    let user = JSON.stringify(formData, null, 2)
    console.log("user to be generated",user)
    const requestData = [formData];
    console.log("data to be generated by excel",requestData)

    try {
        const result = await createUser(requestData); // Call API function
        console.log("Response from API:", result);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
  };

  function convertToExcelFormat( // filter logic response to excel response
    transformedData: Record<string, any>[],
    originalHeaders: string[]
  ): any[][] {
    // First row should contain headers
    const result: any[][] = [originalHeaders];

    // Convert each object back to an array using the headers' order
    transformedData.forEach((obj) => {
      const row = originalHeaders.map((key) => obj[key] ?? ""); // Maintain order and replace undefined with ""
      result.push(row);
    });

    return result;
  }


  return (
    <div className="max-w-2xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-xl font-bold mb-4">Create User</h2>
      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
        {Object.keys(formData).map((key) => (
          <div key={key} className="flex flex-col">
            <label className="text-sm font-semibold capitalize" htmlFor={key}>{key.replace(/_/g, " ")}</label>
            <input
              type={key === "enabled" ? "checkbox" : "text"}
              id={key}
              name={key}
              value={(formData as any)[key] || ""}
              onChange={handleChange}
              className="border p-2 rounded-md"
            />
          </div>
        ))}
        <button type="submit" className="mt-4 bg-blue-500 text-white p-2 rounded-md">
          Submit
        </button>
      </form>
    </div>
  );
};

export default CreateUser;
